import { render, staticRenderFns } from "./ExtOrderItemTable.vue?vue&type=template&id=c5749be0&scoped=true&"
import script from "./ExtOrderItemTable.vue?vue&type=script&lang=ts&"
export * from "./ExtOrderItemTable.vue?vue&type=script&lang=ts&"
import style0 from "./ExtOrderItemTable.vue?vue&type=style&index=0&id=c5749be0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5749be0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VChip,VIcon,VSimpleTable,VTextField})
